import { makeStyles } from '@material-ui/core/styles';

const tabStyles = theme => {
  return {
    root: {
      color: '#87919d',
    },
    selected: {
      color: theme.palette.primary.main,
      fontFamily: 'proximanova-bold',
      marginBottom: 5,
      fontSize: '1.2em'
    }
  }
}

const tabsStyles = theme => {
  return {
    indicator: {
      visibility: 'hidden'
    }
  }
}


export const useTabStyles = makeStyles(tabStyles)
export const useTabsStyles = makeStyles(tabsStyles)
